module.exports = __webpack_public_path__ + "static/media/M21ws.da54e723.pdf";